// A place to keep your menu scripting (ex. toggling a mobile menu)
(function($){
	// Handle menu interactions
	$(".main-menu-toggle").click(function(e) {
		mainNav(e);
	});

	function mainNav(e) {
		e.preventDefault()

		$(".main-menu-toggle").toggleClass("cross");
		$("body").toggleClass("modal-open");
		$(".menus").toggleClass("open");
	}



  //Listen for menu clicks with anchors, to close the menu 
  $(document).on('click', '.menus.open li.current-menu-item a:not(.expand)', function () {
    mainNav();
  });

  // Drop-down menu when needed
	$('a.expand').click(function() {
		$(this).toggleClass('open');
		$(this).parents('li').find('.sub-menu').slideToggle();
	});

	$('li.menu-item-has-children').hoverIntent({
		over() {
			$(this).addClass('dropdown-open');
			$(this).find('.sub-menu').slideDown();
		},
		out() {
			$(this).removeClass('dropdown-open');
			$(this).find('.sub-menu').slideUp();
		},
		sensitivity: 5,
		timeout: 200
	});

})(jQuery);
